/*eslint-disable*/
import React, { useEffect } from 'react';
import { TableColumn } from 'react-data-table-component';
import { DefaultTable } from 'src/components';
import { Container } from '../../styles';
import {
  HeaderLine,
  HeaderRightItems,
  ItemContainer,
  TitleWrapper,
  TitleWrapperText,
} from '../personal-dependents-tab/styles';
import YearEndFormsService from 'src/services/year-end-forms.service';
import { useQuery } from '@tanstack/react-query';
import { IEmployeeYearEndForm } from 'src/interfaces/year-end-form-employee';
import { useTypedSelector } from 'src/hooks/useTypedSelector';
const TaxFormsTab: React.FC = () => {
  const { selectedEmployee } = useTypedSelector(state => state.employees.data);
  const {
    isLoading: employeeFormLoading,
    isFetching: employeeFormFetching,
    data: employeeForm,
  } = useQuery(['employee-form-list'], () =>
    YearEndFormsService.getYearEndFormsByEmployee(selectedEmployee.employee?.id)
  );

  const columns: TableColumn<IEmployeeYearEndForm>[] = [
    {
      name: 'Control Number',
      selector: (row: IEmployeeYearEndForm) => row.controlNumber,
      sortable: true,
      width: '200px',
    },
    {
      name: 'Form Issued',
      selector: (row: IEmployeeYearEndForm) => row.year || '',
      sortable: true,
    },
    {
      name: 'Form Uploaded',
      selector: (row: IEmployeeYearEndForm) => row.year || '',
      sortable: true,
    },
    {
      name: 'Form Name',
      selector: (row: IEmployeeYearEndForm) => row.name || '',
      sortable: true,
    },
    {
      name: 'Link',
      button: true,
      cell: (row: any) => (
        <a
          href={
            row.name === 'W2-FORM'
              ? YearEndFormsService.getW2YearEndFormPdf(
                  useTypedSelector(state => state.config.data?.config?.selectedCompanyId || ''),
                  row.controlNumber,
                  true,
                  row.employeeId,
                  row.year
                )
              : YearEndFormsService.get1095YearEndFormPdf(
                  useTypedSelector(state => state.config.data?.config?.selectedCompanyId || ''),
                  row.controlNumber,
                  true,
                  row.employeeId,
                  row.year
                )
          }
          target="_blank"
          rel="noopener noreferrer"
        >
          Download
        </a>
      ),
    },
  ];
  return (
    <Container>
      <ItemContainer>
        <TitleWrapper>
          <TitleWrapperText>Tax-Forms</TitleWrapperText>
          <HeaderLine />
          <HeaderRightItems>
            {/*
<RegularButton>
             {t('employeePage.personalTab.contacts.addButton')}
</RegularButton>
           */}
          </HeaderRightItems>
        </TitleWrapper>
        <DefaultTable
          columns={columns}
          progressPending={employeeFormLoading}
          data={employeeForm?.data as unknown as []}
          pagination={true}
        />
      </ItemContainer>
    </Container>
  );
};
export default TaxFormsTab;
